// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Avatar__Jsx3$Avatar(props) {
  var __size = props.size;
  var name = props.name;
  var size = __size !== undefined ? __size : "small";
  var match;
  if (typeof size === "object") {
    var n = size.VAL;
    match = [
      "",
      {
        height: n.toString() + "px",
        width: n.toString() + "px"
      }
    ];
  } else {
    match = size === "large" ? [
        "w-[90px] h-[90px]",
        undefined
      ] : (
        size === "medium" ? [
            "w-[70px] h-[70px]",
            undefined
          ] : (
            size === "small" ? [
                "w-[50px] h-[50px]",
                undefined
              ] : (
                size === "micro" ? [
                    "w-6 h-6",
                    undefined
                  ] : [
                    "w-10 h-10",
                    undefined
                  ]
              )
          )
      );
  }
  return JsxRuntime.jsx("img", {
              className: TailwindMerge.twMerge([
                    "flex-shrink-0 block rounded-full object-cover",
                    match[0]
                  ]),
              style: match[1],
              title: name,
              alt: name,
              src: props.src,
              onClick: props.onClick
            });
}

var Avatar = {
  make: Avatar__Jsx3$Avatar
};

var make = Avatar__Jsx3$Avatar;

exports.Avatar = Avatar;
exports.make = make;
/* tailwind-merge Not a pure module */
